export enum routeConfig {
  "/dashboard/" = 0,
  "/routes/list" = 1,
}
